export default __webpack_public_path__ + "fc2378ea90ab0953d84bdff3359b395e.png";